import { Phone } from "lucide-react";
import { OFFICE } from "../../data/content";

const Header = () => {
  return (
    <header className="rr-header" data-testid="site-header">
      <div className="rr-container rr-header-inner">
        <a href="#inicio" className="rr-header-brand" data-testid="header-brand">
          <div className="rr-header-logos">
            <div className="logo-badge">
              <img src="/assets/logo-inmobiliaria.jpg" alt="Logo Inmobiliaria Rendón Ramos" />
            </div>
            <div className="logo-badge">
              <img src="/assets/logo-despacho.jpg" alt="Logo Despacho Jurídico Rendón Ramos" />
            </div>
          </div>
          <div>
            <div className="rr-header-title font-display">Rendón Ramos</div>
            <div className="rr-header-sub">Inmobiliaria · Despacho Jurídico</div>
          </div>
        </a>
        <nav className="rr-nav">
          <a href="#inmobiliaria" className="nav-link" data-testid="nav-inmobiliaria">Inmobiliaria</a>
          <a href="#despacho" className="nav-link" data-testid="nav-despacho">Despacho Jurídico</a>
          <a href="#ubicacion" className="nav-link" data-testid="nav-ubicacion">Ubicación</a>
          <a href={OFFICE.phoneTel} className="btn btn-call btn-sm" data-testid="header-call-btn">
            <Phone size={15} />
            {OFFICE.phoneDisplay}
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
